import { getEmpCalendarPunches, getEmpPunchLogs, getEmpPunchReport } from 'services/axios/punchLogs'

export const actions = {
  GET_EMP_PUNCH_LOGS: 'GET_EMP_PUNCH_LOGS',
  GET_EMP_CALENDAR_PUNCH_LOGS: 'GET_EMP_CALENDAR_PUNCH_LOGS',
  GET_EMP_PUNCH_REPORT: 'GET_EMP_PUNCH_REPORT',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const fetchEmpPunchReport = (month, year, selectedEmployeeId, skip = 0, limit = 10) => {
  return async (dispatch) => {
    const response = await getEmpPunchReport(month, year, selectedEmployeeId, skip, limit)

    dispatch({
      type: actions.GET_EMP_PUNCH_REPORT,
      payload: {
        empPunchReport: response?.data || [],
        totalCount: response?.totalCount || response?.count || 0,
      },
    })
  }
}

export const fetchEmpPunchLogs = () => {
  return async (dispatch) => {
    const response = await getEmpPunchLogs()
    dispatch({
      type: actions.GET_EMP_PUNCH_LOGS,
      payload: {
        empPunchLogs: response?.data || [],
      },
    })
  }
}

export const fetchEmpCalendarPunches = () => {
  return async (dispatch) => {
    const response = await getEmpCalendarPunches()
    dispatch({
      type: actions.GET_EMP_CALENDAR_PUNCH_LOGS,
      payload: {
        empCalPunches: response?.data || [],
      },
    })
  }
}
